import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

export const startCheckout = async (lookup_key) => {
  const { data } = await http.post("/payments/checkout", {
    lookup_key,
    origin_url: window.location.origin,
  });
  return data;
};

export const getPaymentStatus = (session_id) =>
  http.get(`/payments/status/${session_id}`).then((r) => r.data);

export const paypalCapture = (orderId) => http.post(`/paypal/order/${orderId}/capture`).then((r) => r.data);
export const paypalSubConfirm = (subId) => http.post(`/paypal/subscription/${subId}/confirm`).then((r) => r.data);

export const sendContact = (payload) => http.post("/contact", payload).then((r) => r.data);
export const bookCall = (payload) => http.post("/book-call", payload).then((r) => r.data);
export const subscribeNewsletter = (payload) => http.post("/newsletter", payload).then((r) => r.data);
export const mediaUrl = (id) => (id ? `${API}/media/${id}` : null);
